/**
 * /app/$tenantSlug/settings/departments — Settings › Company › Departments
 * (migration 169, spec docs/superpowers/specs/2026-11-02-checklists-preboarding.md §1).
 *
 * HR-admin only — the backend's hrRole gate on every write (and on the
 * suggestions) is the boundary; the role check below is the UX mirror.
 * Reachable on every plan, POSH only included (it has the people list).
 */

import { createFileRoute } from "@tanstack/react-router";
import { useHrRoles } from "@/components/hr/use-hr-roles";
import { SettingsPageHeader } from "@/components/shared/settings-page-header";
import { SettingsShell } from "@/components/shared/settings-shell";
import { SETTINGS_GROUPS } from "@/lib/settings-nav";
import { DepartmentsSettings } from "@/components/settings/departments-settings";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/settings/departments")({
  component: SettingsDepartmentsRoute,
});

function SettingsDepartmentsRoute() {
  const { isHrAdmin } = useHrRoles();
  return (
    <>
      <SettingsPageHeader />
      <SettingsShell groups={SETTINGS_GROUPS}>
        {isHrAdmin ? (
          <DepartmentsSettings />
        ) : (
          <Card>
            <CardContent className="py-12 text-center text-sm text-muted-foreground">
              Departments are managed by HR admins.
            </CardContent>
          </Card>
        )}
      </SettingsShell>
    </>
  );
}
